export default __webpack_public_path__ + "static/media/why_img.49249e9a.svg";